/**
 * Inject values into fields when a HubSpot form is ready.
 *
 * @link https://developers.hubspot.com/docs/api-reference/global-form-events/guide
 *
 * @param   {string}  hs-form-event:on-ready  The "on ready" event to listen for
 * @param   {function}  function              Callback function when the HubSpot form is ready
 * @param   {Event}  e                        Event details from the form that triggered the event
 */
window.addEventListener('hs-form-event:on-ready', async function (e) {
	// 1. Get the form instance safely
	const form = window.HubSpotFormsV4?.getFormFromEvent(e);
	if (!form) {
		return;
	}
	const inputName = '0-1/form_submission_url';
	try {
		const fields = await form.getFormFieldValues();
		const fieldExists = fields.some((field) => field.name === inputName);
		if (fieldExists) {
			form.setFieldValue(inputName, window.location.href);
		}
	} catch (err) {
		console.error('Error interacting with HubSpot form:', err);
	}
});

/**
 * Send events after successful HubSpot form submission
 *
 * @link https://developers.hubspot.com/docs/api-reference/global-form-events/guide
 *
 * @param   {string}  hs-form-event:on-submission:success  The "submission success" event to listen for
 * @param   {function}  function              Callback function when the HubSpot form is ready
 * @param   {Event}  e                        Event details from the form that triggered the event
 */
window.addEventListener('hs-form-event:on-submission:success', function (e) {
	// Check if the V4 library is available
	if (window.HubSpotFormsV4) {
		const formInstance = window.HubSpotFormsV4.getFormFromEvent(e);
		const formId = formInstance.getFormId();

		// Push to Google Tag Manager
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'hs_form_submission',
			gf_form_id: formId,
			form_id: formId,
			page_path: window.location.pathname,
		});

		// Send straight to GA4 (via the GTM-loaded Google tag) so form_id
		// lands in BigQuery without needing a dedicated GTM tag
		window.gtag?.('event', 'hs_form_submission', { form_id: formId });
	}
});

/**
 * Send a GA4 event the first time a visitor interacts with a HubSpot form
 *
 * Fires once per form instance on the first focus of any field inside it.
 * Works for embeds rendered into the page (not iframe embeds), where the
 * form ID is exposed as a data-form-id attribute on a wrapping element.
 */
const startedForms = new WeakSet();
document.addEventListener('focusin', function (e) {
	const formEl = e.target.closest?.('[data-form-id]');
	if (!formEl || startedForms.has(formEl)) {
		return;
	}
	startedForms.add(formEl);

	const formId = formEl.getAttribute('data-form-id');
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'hs_form_start',
		form_id: formId,
		page_path: window.location.pathname,
	});
	window.gtag?.('event', 'hs_form_start', { form_id: formId });
});
